import * as Roles from '@/constants/roles';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.provide('role', Roles);
});
